import dayjs from "dayjs";
import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
//import { sortByOptions } from "../../utils/constants";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Filters from "../../common/reports/Filters";
import {
  BETWEEN,
  DATE,
  GTE,
  LIKE,
  LTE,
} from "../../common/reports/reportConstants";
import { createFilterParam } from "../../common/reports/reportUtils";
import Button from "../../framework/Button";
import DatePicker from "../../framework/date/DatePicker";
import GlobalContext from "../../framework/GlobalContext";
import NumberInput from "../../framework/NumberInput";
import TextInput from "../../framework/TextInput";
import { executeScroll, isEmpty } from "../../utils/utils";
import Shortcut from "../../framework/Shortcut";
import SelectInput from "../../framework/SelectInput";
import { fetchBranches } from "../../services/branch-service";
const StockAuditReportFilter = ({
  onFilterShow,
  applyFilterOnMount = true,
  refreshData = false,
  //applyFilters = () => {},
  reportRef,
}) => {
  const [startDate, setStartDate] = useState(dayjs().subtract(7, "day"));
  const [endDate, setEndDate] = useState(dayjs());
  const [auditor, setAuditor] = useState("");
  const [limit, setLimit] = useState(100);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [branchSuggestions, setBranchSuggestions] = useState([]);
  const filterStartDateRef = useRef();
  const filterEndDateRef = useRef();
  const filterBranchCodeRef = useRef();
  const filterAuditorRef = useRef();
  const filterLimitRef = useRef();
  const applyFilterRef = useRef();
  const [orderBy] = useState([{ fieldName: "createdTime", orderType: "desc" }]);

  const { setCurrentComponent } = useContext(GlobalContext);
  const handleBranchInputChange = (event) => {
    const value = event.target.value || "";
    if (value.length > 2) {
      setBranchSuggestions([]);
      fetchBranches({ search: value }).then((resp) => {
        let updatedResp = resp.result.rows.map((branch) => ({
          id: branch._id,
          label: branch.code,
        }));
        setBranchSuggestions(updatedResp);
      });
    }
  };
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      const _startDate = startDate?.format("DD/MM/YYYY");
      const _endDate = endDate?.format("DD/MM/YYYY");
      if (_startDate && !_endDate) {
        filters.push(createFilterParam("createdTime", _startDate, DATE, GTE));
      }
      if (!_startDate && _endDate) {
        filters.push(createFilterParam("createdTime", _endDate, DATE, LTE));
      }
      if (_startDate && _endDate) {
        filters.push(
          createFilterParam(
            "createdTime",
            { start: _startDate, end: _endDate },
            DATE,
            BETWEEN
          )
        );
      }
      if (!isEmpty(auditor)) {
        filters.push(createFilterParam("auditor", auditor, "string", LIKE));
      }
      if (!isEmpty(selectedBranches)) {
        const filterParam = createFilterParam(
          "branchCode",
          selectedBranches.label,
          "string",
          LIKE
        );
        filters.push(filterParam);
      }
      result.filters = filters;
      result.isFilterChanged = isFilterChanged;
      if (orderBy?.length) {
        result.orderBy = orderBy;
      }
      if (!isEmpty(limit)) {
        result.limit = limit;
      }

      reportRef.current?.applyFilters(result);
    },
    [selectedBranches, auditor, endDate, limit, orderBy, startDate, reportRef]
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      event.preventDefault();
      return applyFilterRef.current.click();
    }
  }, []);
  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_start_date"
            label="Start Date"
            inputRef={filterStartDateRef}
            onChange={(value) => setStartDate(value)}
            onFocus={() => setCurrentComponent("sar_filter_start_date")}
            value={startDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_start_date",
                down: "sar_filter_end_date",
                left: "sar_filter_start_date",
                right: "sar_filter_end_date",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <DatePicker
            id="sar_filter_end_date"
            label="End Date"
            inputRef={filterEndDateRef}
            onChange={(value) => setEndDate(value)}
            onFocus={() => {
              executeScroll(filterEndDateRef);
              setCurrentComponent("sar_filter_end_date");
            }}
            value={endDate}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_start_date",
                down: "sar_filter_branch_code",
                left: "sar_filter_start_date",
                right: "sar_filter_branch_code",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="sar_filter_branch_code"
            value={selectedBranches}
            ref={filterBranchCodeRef}
            options={branchSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label;
            }}
            onChange={(e, value) => {
              setSelectedBranches(value);
            }}
            onFocus={() => {
              executeScroll(filterBranchCodeRef);
              setCurrentComponent("sar_filter_branch_code");
            }}
            disableClearable={false}
            onInputChange={handleBranchInputChange}
            label="Branch Code"
            disableCloseOnSelect={false}
            noOptionsText="Search branch code"
            markers={JSON.stringify({
              up: "sar_filter_end_date",
              down: "sar_filter_auditor",
              right: "sar_filter_auditor",
              left: "sar_filter_end_date",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <TextInput
            id="sar_filter_auditor"
            label="Auditor"
            ref={filterAuditorRef}
            value={auditor}
            onChange={(e) => setAuditor(e.target.value)}
            onFocus={() => {
              executeScroll(filterAuditorRef);
              setCurrentComponent("sar_filter_auditor");
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_branch_code",
                down: "sar_filter_limit",
                left: "sar_filter_branch_code",
                right: "sar_filter_limit",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            id="sar_filter_limit"
            label="Limit"
            ref={filterLimitRef}
            onValueChange={(values) => setLimit(values.floatValue)}
            isAllowed={(values) => values?.formattedValue <= 999999}
            onFocus={() => {
              executeScroll(filterLimitRef);
              setCurrentComponent("sar_filter_limit");
            }}
            value={limit}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "sar_filter_auditor",
                down: "sar_apply_filter_button",
                left: "sar_filter_auditor",
                right: "sar_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="sar_apply_filter_button"
            label="Apply"
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            ref={applyFilterRef}
            onClick={() => applyFilterHandler(true)}
            markers={JSON.stringify({
              up: "sar_filter_limit",
              left: "sar_filter_limit",
              down: "sar_apply_filter_button",
              right: "sar_apply_filter_button",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  useEffect(() => {
    if (onFilterShow) {
      filterStartDateRef?.current.focus({ preventScroll: true });
    }
  }, [onFilterShow]);
  useEffect(() => {
    if (refreshData) {
      applyFilterHandler(true);
    }
  }, [refreshData, applyFilterHandler]);
  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);

  useEffect(() => {
    if (applyFilterOnMount) applyFilterHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applyFilterOnMount]);

  return (
    <Filters
      title="Stock Audit Report Filters"
      filterContent={filterContent}
      filterFooter={filterFooter}
    />
  );
};

export default StockAuditReportFilter;
